import { Button as MuiButton, Card, Link, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import ClaimScreen, { ClaimBar } from '@/james-playground/aa-family-claim/ClaimScreen';
import { say, type Voice } from '@/james-playground/aa-family-claim/claim/asks';
import {
  HANDOFF,
  HANDOFF_COMMON,
} from '@/james-playground/aa-family-claim/claim/claim.content';
import { type Handoff } from '@/james-playground/aa-family-claim/claim/engine';

/**
 * Where the AA1 does not fit (spec 1): why, what to claim instead, how to start
 * it, and that nothing told so far is lost.
 */
const HandoffScreen = ({
  handoff,
  voice,
  onBack,
  onAdviser,
}: {
  handoff: Handoff;
  voice: Voice;
  onBack: () => void;
  onAdviser?: () => void;
}) => {
  const copy = HANDOFF[handoff];
  return (
    <ClaimScreen
      bar={<ClaimBar onBack={onBack} />}
      title={say(copy.title, voice)}
      description={say(copy.body, voice)}
      footer={
        <>
          <MuiButton
            variant='contained'
            size='large'
            fullWidth
            href={copy.action.href}
            target='_blank'
            rel='noreferrer'
          >
            {copy.action.label}
          </MuiButton>
          <MuiButton variant='outlined' size='large' fullWidth onClick={onAdviser}>
            {HANDOFF_COMMON.adviser}
          </MuiButton>
        </>
      }
    >
      <Card sx={{ p: 2 }}>
        <Stack spacing={1.5}>
          {copy.phone && (
            <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1.25}>
              <Icon icon={'phone' as never} fontSize={14} />
              <Link href={`tel:${copy.phone.replace(/\s/g, '')}`} variant='body1'>
                {copy.phone}
              </Link>
            </Stack>
          )}
          <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1.25}>
            <Icon icon={'circle-check' as never} fontSize={14} />
            <Typography variant='body2'>{HANDOFF_COMMON.kept}</Typography>
          </Stack>
        </Stack>
      </Card>
      <Link component='button' type='button' variant='body2' onClick={onBack} sx={{ alignSelf: 'flex-start' }}>
        {HANDOFF_COMMON.back}
      </Link>
    </ClaimScreen>
  );
};

export default HandoffScreen;
